$(document).ready(function () {
    function addItem(form_id) {
        $.ajax({
            'type': 'POST',
            'url': '/cart/add.js',
            'dataType': 'json',
            'data': $('#'+form_id).serialize(),
            'success': Shopify.onSuccess,
            'error': Shopify.onError
        });
    }

    $(".addtocart").click(function (e) {
        var elem = $(this);
        $(elem).prop("disabled", true);

        e.preventDefault();
        addItem('add-item-form');
    });

    // for adding to cart from a collection page
    $(".addtocart-collection").click(function (e) {
        var elem = $(this);
        $(elem).prop("disabled", true);
        var productID = $(this).closest('form').attr('id');
        console.log(productID)
        e.preventDefault();
        addItem(productID);
    });
  
    Shopify.onSuccess = function (addedProduct, response) {
        var elem = $('.addtocart');
        elem.removeAttr("disabled");

        var elemCollection = $('.addtocart-collection');
        elemCollection.removeAttr("disabled");

        $.ajax({
            'type': 'GET',
            'url': '/cart.js',
            'dataType': 'json',
            success: function (response) {
                renderCart(response);
                openCartFlyout();
            },
            'error': Shopify.onError
        });
    };
  
    Shopify.onError = function (XMLHttpRequest, textStatus) {
        // Shopify returns a description of the error in XMLHttpRequest.responseText.
        // It is JSON.
        // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
        var data = eval('(' + XMLHttpRequest.responseText + ')');

        if (!!data.message) {
            alert(data.message + '(' + data.status  + '): ' + data.description);
        } else {
            alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
        }

        $('.addtocart').removeAttr("disabled");
        $('.addtocart-collection').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
        var fullMessages = [];
        
        jQuery.each(errors, function (attribute, messages) {
            jQuery.each(messages, function (index, message) {
                fullMessages.push(attribute + ' ' + message);
            });
        });
        
        return fullMessages;
    };
});

/**
 * Footer Functions
 */
$(document).ready(function () {
  var windowHeightMinusFooterHieght = ($(window).height() - $('#main-wrapper').height()) + $('#main-footer').height();
  $('#main-footer').css({minHeight: windowHeightMinusFooterHieght + 58});
});

/**
 * Cart functions
 */
function openCartFlyout() {
  var cartSlide = $('#cart-flyout');
  var mainSlide = $('#main-wrapper');

  if(!$(cartSlide).hasClass('active')) {
    if($('.cart-items').find('.cart-item').length > 0) {
      $('#cart-flyout #checkout').removeClass('inactive');
    } else {
      $('#cart-flyout #checkout').addClass('inactive');
    }

    $('.toggle-cart').addClass('active');
    cartSlide.addClass('active');
    cartSlide.animate({right: 0}, 500);
    mainSlide.animate({left: '-340px', width: $(window).width()}, 500);
  }
}

function closeCartFlyout() {
  var cartSlide = $('#cart-flyout');
  var mainSlide = $('#main-wrapper');

  if($(cartSlide).hasClass('active')) {
    $('.toggle-cart').removeClass('active');
    cartSlide.removeClass('active');
    cartSlide.animate({right: '-340px'}, 500);
    mainSlide.animate({left: 0}, 500, function() {
      mainSlide.css({width: 'auto'});
    });
  }
}

function updateCartItem(lineID, qty) {
  var data = {line: lineID, quantity: qty};

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: data,
    success: function(response) {
      renderCart(response);
    },
    error: Shopify.onError
  });
}

function renderCart(response) {
  
  var itemsText = response.item_count;

  itemsText += (response.item_count === 1) ?  ' Item' : ' Items';
  $('#cart-flyout .number-of-items').text(itemsText);
  $('#main-header #cart-info .toggle-cart').text(response.item_count);
  $('#cart-flyout .subtotal-price').text('$' + (response.total_price/100).toFixed(2));

  $('#cart-flyout .cart-items').html('');
  for(var i=0; i<response.items.length; i++) {
    $('#cart-flyout .cart-items').append('<div class="cart-item"><div class="image"><img src="'+response.items[i].image+'" alt="'+response.items[i].product_title +'"></div><div class="info"><a href="/cart/change?quantity=0" class="remove-item" data-lid="'+(i + 1)+'"><div class="remove-cart-item-icon" style="background-image: url(//www.the-posters.com/cdn/shop/t/1/assets/closeicon.png?v=141604897207491422181417353697)"></div></a><h3>'+response.items[i].product_title+'</h3><div class="qty">QTY <input type="text" size="2" name="updates[]" id="updates_834788403" value="'+response.items[i].quantity+'" onfocus="this.select();" class="tc item-quantity"> <a href="#" class="update-cart" data-lid="'+(i+1)+'">Update</a></div><div class="price">$'+((response.items[i].price / 100) * parseInt(response.items[i].quantity)).toFixed(2) +'</div></div></div>');
  }

  if($('.cart-items').find('.cart-item').length > 0) {
    $('#cart-flyout #checkout').removeClass('inactive');
  } else {
    $('#cart-flyout #checkout').addClass('inactive');
  }
}

$(document).ready(function () {
  $('.toggle-cart').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    var cartSlide = $('#cart-flyout');

    if (cartSlide.hasClass('active')) {
      closeCartFlyout();
    } else {
      openCartFlyout();
    }

  });

  $('body').on('click', '#cart-flyout', function (e){
    e.stopPropagation();
  });

  $('#cart-flyout .item-quantity').on('click', function (e){
    e.stopPropagation();
  });

  $('html').on('click', function (e) {
    closeCartFlyout();
  });

  $('body').on('click', '#cart-flyout .remove-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    updateCartItem($(this).closest('a').data('lid'), 0);
  });

  $('body').on('click', '#cart-flyout .update-cart', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var qty = $(this).closest('a').siblings('.item-quantity').val();
    updateCartItem($(this).closest('a').data('lid'), qty);
  });

  $('body').on('click', '#cart-flyout #checkout', function (e) {
    if($('#checkout').hasClass('inactive')) {
      e.preventDefault();
      e.stopPropagation();

      return false;
    }
  });

  $('body').on('blur', '.gift-note textarea', function(){
    var data = $('.gift-note textarea').serialize();

    $.ajax({
            'type': 'POST',
            'url': '/cart/update.js',
            'data': data,
            'dataType': 'json',
            success: function (response) {
            },
            'error': Shopify.onError
        });
  });


});

/**
 * Homepage Featured Product
 */
$(document).ready(function () {
  $(window).resize(homepageFeatureProductSize);

  function homepageFeatureProductSize() {
    var $image = $('.previewImage_container');
    var ratio = $image.width() / $image.height();

    if ((($(window).height() - 280) * ratio) <= 500 && (($(window).height() - 280) * ratio) <= $(window).height() - 280 && (($(window).height() - 280) * ratio) > 450) {
      $image.css({
        'maxWidth': 'auto'
      });
      
      $image.width(($(window).height() - 280) * ratio);
      $image.height($image.width() * (1 / ratio));
    }
  }
  
  // Run on page load
  homepageFeatureProductSize();
});

/**
 * Homepage slideshow
 */
$(document).ready(function () {
  // Enable clicks to the main container
  $('.product-slideshow').on('click', '.previewImage_container', function () {
    // Go to child link href
    document.location = $(this).find('a').attr('href');
  });
  var cycleSlides = function(){
    
  var slideshow = $('.product-slideshow');
  var leftControl = $(slideshow).find('.left.control');
  var rightControl = $(slideshow).find('.right.control');

  var current = slideshow.find('.active-product');
    var next = slideshow.find('.active-product').next().filter('.previewImage_container');
    var prevPrev = current;
    var nextNext = slideshow.find('.active-product').next().next().filter('.previewImage_container');

    if (next.length <= 0) {
      next = slideshow.find('.previewImage_container').first();
    }

    if (nextNext.length <= 0 && slideshow.find('.previewImage_container').last().hasClass('active-product')) {
      nextNext = slideshow.find('.previewImage_container').first().next().filter('.previewImage_container');
    } else if(nextNext.length <= 0) {
      nextNext = slideshow.find('.previewImage_container').first().filter('.previewImage_container');
    }

    if (next.length > 0) {
      current.removeClass('active-product').fadeOut(300, function(){
        next.addClass('active-product').fadeIn(300);

        if (prevPrev.length > 0) {
          leftControl.addClass('active');
          leftControl.find('.poster-preview').find('.image').html(prevPrev.find('img').clone());
          leftControl.find('.poster-preview').find('.artist').text(prevPrev.find('.date').text());
        }

        if(nextNext.length > 0) {
          rightControl.addClass('active');
          rightControl.find('.poster-preview').find('.image').html(nextNext.find('img').clone());
          rightControl.find('.poster-preview').find('.artist').text(nextNext.find('.date').text());
        }
      });
    }
  }
  var cycleStart;

  function cycleThrough() {
    cycleStart = setInterval(cycleSlides, 3500);
  }

  cycleThrough();
  
  if ($('.product-slideshow').length > 0) {
    $('.product-slideshow').each(function (index, value) {
      var leftControl = $(this).find('.left.control');
      var rightControl = $(this).find('.right.control');
      var slideshow = $(this);

      var controlOffset = Math.min(320, ($(window).first().height()/2 - 110));
      leftControl.css({top: controlOffset });
      rightControl.css({top: controlOffset });

      slideshow.find('.previewImage_container').hide().first().show().addClass('active-product');

      leftControl.on('click', function(){
        clearInterval(cycleStart);
        var current = slideshow.find('.active-product');
        var prev = slideshow.find('.active-product').prev().filter('.previewImage_container');
        var prevPrev = slideshow.find('.active-product').prev().prev().filter('.previewImage_container');
        var nextNext = current;

        if (prev.length <= 0) {
          prev = slideshow.find('.previewImage_container').last();
        }

        if (prevPrev.length <= 0 && slideshow.find('.previewImage_container').first().hasClass('active-product')) {
          prevPrev = slideshow.find('.previewImage_container').last().prev().filter('.previewImage_container');
        } else if (prevPrev.length <= 0) {
          prevPrev = slideshow.find('.previewImage_container').last().filter('.previewImage_container');
        }

        if (prev.length > 0) {
          current.removeClass('active-product').fadeOut(300, function(){
            prev.addClass('active-product').fadeIn(300);

            if (prevPrev.length > 0) {
              leftControl.addClass('active');
              leftControl.find('.poster-preview').find('.image').html(prevPrev.find('img').clone());
              leftControl.find('.poster-preview').find('.artist').text(prevPrev.find('.date').text());
            }

            if (nextNext.length > 0) {
              rightControl.addClass('active');
              rightControl.find('.poster-preview').find('.image').html(nextNext.find('img').clone());
              rightControl.find('.poster-preview').find('.artist').text(nextNext.find('.date').text());
            }
          });
        }
        
      });

      rightControl.on('click', function(){
        clearInterval(cycleStart);
        var current = slideshow.find('.active-product');
        var next = slideshow.find('.active-product').next().filter('.previewImage_container');
        var prevPrev = current;
        var nextNext = slideshow.find('.active-product').next().next().filter('.previewImage_container');

        if (next.length <= 0) {
          next = slideshow.find('.previewImage_container').first();
        }

        if (nextNext.length <= 0 && slideshow.find('.previewImage_container').last().hasClass('active-product')) {
          nextNext = slideshow.find('.previewImage_container').first().next().filter('.previewImage_container');
        } else if(nextNext.length <= 0) {
          nextNext = slideshow.find('.previewImage_container').first().filter('.previewImage_container');
        }

        if (next.length > 0) {
          current.removeClass('active-product').fadeOut(300, function(){
            next.addClass('active-product').fadeIn(300);

            if (prevPrev.length > 0) {
              leftControl.addClass('active');
              leftControl.find('.poster-preview').find('.image').html(prevPrev.find('img').clone());
              leftControl.find('.poster-preview').find('.artist').text(prevPrev.find('.date').text());
            }

            if(nextNext.length > 0) {
              rightControl.addClass('active');
              rightControl.find('.poster-preview').find('.image').html(nextNext.find('img').clone());
              rightControl.find('.poster-preview').find('.artist').text(nextNext.find('.date').text());
            }
          });
        }
      });

    });
  }
});

/**
 * Product Expiration Dates
 * Expected expDate format "YYYY-MM-DD"
 */
function daysRemaining(expDate) {
  var _daysRemaining;
  var ms;
  var today = moment();

  expDate = moment(expDate, "YYYY-MM-DD");
  ms = expDate.diff(today);
  _daysRemaining = moment.duration(ms);
  
  return (Math.floor(_daysRemaining.asDays()) + 1);
}

$(document).ready(function () {
  var days;

  $('#active-products .product').each(function (index, value) {
    if ($(value).data('expdate') !== undefined) {
      days = daysRemaining($(value).data('expdate'));

      if (days < 0) {
        $(this).hide();
      } else {
        $(this).find('.days-remaining').html(days);
      }
    }
  });

  $('.artist-products .product').each(function (index, value) {
    if ($(value).data('expdate') !== undefined) {
      days = daysRemaining($(value).data('expdate'));

      if (days < 0) {
        $(this).find('.availability').hide();
      } else {
        $(this).find('.days-remaining').html(days);
      }
    }
  });

  $('.previewImage_container').each(function (index, value) {
    if ($(value).data('expdate') !== undefined) {
      days = daysRemaining($(value).data('expdate'));

      if (days < 0) {
        $(this).find('.availability').hide();
      } else {
        $(this).find('.days-remaining').html(days);
      }
    }
  });

  
});

$(document).ready(function () {
  var days;
  
  if ($('#product #details #availability').data('expdate') !== undefined) {
    days = daysRemaining($('#product #details #availability').data('expdate'));
    
    if (days > 0) {
      $('#product #details #availability').find('.days-remaining').html(days);
    } else {
      $('#product #details #availability').hide();
    }
  }
});

/**
 * Image Swapping on Products
 */
$(document).ready(function () {
  var $featuredImage = $('#featured-image');
  var $thumbnails = $('#thumbs');
  var $zoomModal = $('#zoom-image');

  $thumbnails.find('a').on('click', switchImage);
  $featuredImage.find('a').on('click', zoomImage);
  $zoomModal.on('click', closeZoomImage);

  function switchImage(e) {
    e.preventDefault();
    var url = $(e.target).closest('a').attr('href');
    var featuredImage = $featuredImage.find('img');

    $featuredImage.find('a').attr('href', url);
    featuredImage.fadeOut(300, function() {
      featuredImage.attr('src', url).fadeIn(300);
    });
  }

  function zoomImage(e) {
    e.preventDefault();
    var featuredImage = $featuredImage.find('img');
    $zoomModal.css({backgroundImage: 'url('+featuredImage.attr('src')+')', height: $(window).height(), width: $(window).width()});
    $zoomModal.fadeIn(300);

    $zoomModal.mousemove(function(e){
      var x = ((e.pageX * 100) / $(window).width());
      var y = ((e.pageY * 100) / $(window).height());

      $zoomModal.css({backgroundPosition: x + '% ' + y + '%'});
      
    });
  }

  function closeZoomImage(e) {
    $zoomModal.fadeOut(300);
  }
});


// jQuery(window).load(function(){

//   if ( $('.slides li').size() > 1 ) {

//     $('.flexslider').flexslider({
//       animation: "slide",
//       slideshow: true,
//       animationDuration: 700,
//       slideshowSpeed: 6000,
//       animation: "fade",
//       controlsContainer: ".flex-controls",
//       controlNav: false,
//       keyboardNav: true
//     }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

//   }

//   $("select.loc_on_change").change(function(){
//   	if($(this).attr("value") == "#") return false;
//   	window.location = $(this).attr("value");
//   });

  
// });

// /*============================*/
// /* Update main product image. */
// /*============================*/
// var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
//   // newImageSrc is the path of the new image in the same size as originalImage is sized.
//   // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
//   // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
//   jQuery(mainImageDomEl).attr('src', newImageSrc);
//   
//   if ($(window).width() > 782) {jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_master', '') } );}  
//   
// };

   
// jQuery(document).ready(function($){
    	
//   $("a.zoom").fancybox({
//     padding:0,
//     'titleShow': false,
//     overlayColor: '#000000',
//     overlayOpacity: 0.2
//   });
  
//   /* Update main product image when a thumbnail is clicked. */
//   /*==========================*/
//   $('#product .thumbs a').on('click', function(e) { 
//     e.preventDefault();
//     switchImage($(this).attr('href'), null, $('.featured img')[0]);
//   } );
  
//   
//   /* Initialize zoom on main product image */
//   var mainProductImage = $('.featured img');
//   if (mainProductImage.size()) {
//     if ($(window).width() > 782) {
//     var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
//     $('.featured img')
//       .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
//       .css('display', 'block')
//       .parent()
//       .zoom( { url: zoomedSrc } );
// 	}
//   }
//   
//   $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
   
//   $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
//     $(this).blur();
//   })
  
//   $("li.dropdown").hover(function(){
//     $(this).children('.dropdown').show();
//     $(this).children('.dropdown').stop();
//     $(this).children('.dropdown').animate({
//       opacity: 1.0
//     }, 200);
//   }, function(){
//     $(this).children('.dropdown').stop();
//     $(this).children('.dropdown').animate({
//       opacity: 0.0
//     }, 400, function(){
//       $(this).hide();
//     });
//   });
  
// }); // end document ready

// /* jQuery css bezier animation support -- Jonah Fox */
 
// ;(function($){
 
//   $.path = {};
 
//   var V = {
//     rotate: function(p, degrees) {
//       var radians = degrees * Math.PI / 180,
//         c = Math.cos(radians),
//         s = Math.sin(radians);
//       return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
//     },
//     scale: function(p, n) {
//       return [n*p[0], n*p[1]];
//     },
//     add: function(a, b) {
//       return [a[0]+b[0], a[1]+b[1]];
//     },
//     minus: function(a, b) {
//       return [a[0]-b[0], a[1]-b[1]];
//     }
//   };
 
//   $.path.bezier = function( params, rotate ) {
//     params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
//     params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
//     this.p1 = [params.start.x, params.start.y];
//     this.p4 = [params.end.x, params.end.y];
 
//     var v14 = V.minus( this.p4, this.p1 ),
//       v12 = V.scale( v14, params.start.length ),
//       v41 = V.scale( v14, -1 ),
//       v43 = V.scale( v41, params.end.length );
 
//     v12 = V.rotate( v12, params.start.angle );
//     this.p2 = V.add( this.p1, v12 );
 
//     v43 = V.rotate(v43, params.end.angle );
//     this.p3 = V.add( this.p4, v43 );
 
//     this.f1 = function(t) { return (t*t*t); };
//     this.f2 = function(t) { return (3*t*t*(1-t)); };
//     this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
//     this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
//     /* p from 0 to 1 */
//     this.css = function(p) {
//       var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
//       if (rotate) {
//         css.prevX = this.x;
//         css.prevY = this.y;
//       }
//       css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
//       css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
//       css.left = css.x + "px";
//       css.top = css.y + "px";
//       return css;
//     };
//   };
 
//   $.path.arc = function(params, rotate) {
//     for ( var i in params ) {
//       this[i] = params[i];
//     }
 
//     this.dir = this.dir || 1;
 
//     while ( this.start > this.end && this.dir > 0 ) {
//       this.start -= 360;
//     }
 
//     while ( this.start < this.end && this.dir < 0 ) {
//       this.start += 360;
//     }
 
//     this.css = function(p) {
//       var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
//         css = {};
 
//       if (rotate) {
//         css.prevX = this.x;
//         css.prevY = this.y;
//       }
//       css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
//       css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
//       css.left = css.x + "px";
//       css.top = css.y + "px";
//       return css;
//     };
//   };
 
//   $.fx.step.path = function(fx) {
//     var css = fx.end.css( 1 - fx.pos );
//     if ( css.prevX != null ) {
//       $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
//     }
//     fx.elem.style.top = css.top;
//     fx.elem.style.left = css.left;
//   };
 
// })(jQuery);
